import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarRoute: InvariantJiraRoute = {
	name: 'software-calendar',
	path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
	query: ['date?'],
};
